export const Breakpoints = {
    phone: 576,
    tablet: 768,
    desktop: 992,
    desktopLg: 1200,
}
